import { SHOWCASE_ACTION_TYPES } from "./showcase.types.js";
import { normalizeCardsById, removeCardById, upsertCard } from "../../utils/showcase/showcaseCards";

const SHOWCASE_INITIAL_STATE = {
    preSelectedCardId: null,
    preSelectedCardType: null,
    selectedCardId: null,
    isViewingNewSelection: false,
    isEditingCard: false,
    isAddingCardImgs: false,
    isMovingCard: false,
    cardImgsWereAdded: false,
    newSelectionCardData: {
        name: [],
        cardPath: [],
        cardParallel: {
            cardColor: '',
            cardParallelName: '',
            cardPrintNumber: null,
            cardSupply: 0,
        },
        uploadedImage: null,
        imageOrientation: 'vertical'
    },
    cardsById: {}
};

export const showcaseReducer = (state = SHOWCASE_INITIAL_STATE, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case SHOWCASE_ACTION_TYPES.SET_PRESELECTED_CARD_ID:
            return { ...state, preSelectedCardId: payload };
        case SHOWCASE_ACTION_TYPES.SET_PRESELECTED_CARD_TYPE:
            return { ...state, preSelectedCardType: payload };
        case SHOWCASE_ACTION_TYPES.SET_SELECTED_CARD_ID:
            return { ...state, selectedCardId: payload };
        case SHOWCASE_ACTION_TYPES.SET_NEW_SELECTION_CARD_DATA:
            return { ...state, newSelectionCardData: payload };
        case SHOWCASE_ACTION_TYPES.SET_IS_VIEWING_NEW_SELECTION:
            return { ...state, isViewingNewSelection: payload };
        case SHOWCASE_ACTION_TYPES.SET_IS_EDITING_CARD:
            return { ...state, isEditingCard: payload };
        case SHOWCASE_ACTION_TYPES.SET_IS_ADDING_CARD_IMGS:
            return { ...state, isAddingCardImgs: payload };
        case SHOWCASE_ACTION_TYPES.SET_CARD_IMGS_WERE_ADDED:
            return { ...state, cardImgsWereAdded: payload };
        case SHOWCASE_ACTION_TYPES.SET_DREAM_TEAM_MLB:
            return { ...state, cardsById: normalizeCardsById(payload) };
        case SHOWCASE_ACTION_TYPES.UPDATE_DREAM_TEAM_POSITION: {
            const { positionId, updatedData } = action.payload;
            if (!updatedData?.id) return state;
            const card = {
                ...updatedData,
                id: updatedData.id,
                positionId: positionId ?? updatedData.positionId ?? null,
            };
            return { ...state, cardsById: upsertCard(state.cardsById, card) };
        }
        case SHOWCASE_ACTION_TYPES.REMOVE_SHOWCASE_CARD:
            return { ...state, cardsById: removeCardById(state.cardsById, payload) };
        case SHOWCASE_ACTION_TYPES.SET_IS_MOVING_CARD:
            return { ...state, isMovingCard: payload }
        case SHOWCASE_ACTION_TYPES.RESET_SHOWCASE_STATE:
            return SHOWCASE_INITIAL_STATE;
        default:
            return state;
    }
};